import { TechnicalsPivotRow, TechnicalsRowResult } from '../../../util/technicals'

export type TechnicalsCandleSeries = {
    open: number[]
    high: number[]
    low: number[]
    close: number[]
    volume: number[]
    hl2: number[]
    hlc3: number[]
    timestamps: number[]
    lastClose: number
}

export type IndicatorComputeResult = {
    value?: number
    previous?: number
    previousPrevious?: number
    extras: Record<string, number>
}

export type TechnicalsComputedResult = {
    oscillators: TechnicalsRowResult[]
    movingAverages: TechnicalsRowResult[]
    pivots: TechnicalsPivotRow[]
    lastClose?: number
    detailTimeframe: string
}

/** Covers EMA/SMA 200 (+ buffer). Daily store is capped ~200 bars anyway. */
export const DEFAULT_TARGET_BARS = 300
/** Request target in one call when possible; only paginate if the API returns a short page. */
export const CANDLE_PAGE_SIZE = 300
export const CANDLE_CACHE_TTL_MS = 5 * 60 * 1000
export const CONFIG_CACHE_TTL_MS = 24 * 60 * 60 * 1000
export const CONFIG_STORAGE_KEY = 'tick2trade.technicalsConfig.v1'
